import React from "react";

export const ExportIcon = ({ width = 16, height = 16, color = "#DEDEE2" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1V13.3333H7.16667C7.44281 13.3333 7.66667 13.5572 7.66667 13.8333C7.66667 14.1095 7.44281 14.3333 7.16667 14.3333H0.9C0.402943 14.3333 0 13.9304 0 13.4333V0.9C0 0.402943 0.402945 0 0.9 0H8.66765C8.90634 0 9.13526 0.0948211 9.30404 0.263604L11.4031 2.36262C11.5718 2.53141 11.6667 2.76032 11.6667 2.99902V7.83333C11.6667 8.10947 11.4428 8.33333 11.1667 8.33333C10.8905 8.33333 10.6667 8.10947 10.6667 7.83333V3.04044L8.62623 1H1Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 0C8.77614 0 9 0.223858 9 0.5V2.66667H11.1667C11.4428 2.66667 11.6667 2.89052 11.6667 3.16667C11.6667 3.44281 11.4428 3.66667 11.1667 3.66667H8.9C8.40294 3.66667 8 3.26372 8 2.76667V0.5C8 0.223858 8.22386 0 8.5 0Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1464 14.1869C10.3417 14.3821 10.6583 14.3821 10.8536 14.1869L12.8536 12.1869C13.0488 11.9916 13.0488 11.675 12.8536 11.4798L10.8536 9.47978C10.6583 9.28452 10.3417 9.28452 10.1464 9.47978C9.95118 9.67504 9.95118 9.99162 10.1464 10.1869L11.2929 11.3333H8.5C8.22386 11.3333 8 11.5572 8 11.8333C8 12.1095 8.22386 12.3333 8.5 12.3333H11.2929L10.1464 13.4798C9.95118 13.675 9.95118 13.9916 10.1464 14.1869Z"
      fill={color}
    />
  </svg>
);
